import { useEffect, useRef, useState } from "react";
import { useGlobalState } from "../GlobalContext";
import axios from "axios";

export default function Payment(props) {
    const allowedPayments = ["ideal", "paypal", "banktransfer"];
    const [paymentMethods, setPaymentMethods] = useState([]);
    const { loggedInUser } = useGlobalState();

    const hiddenSelects = useRef([]);

    useEffect(() => {
        // Get payments methods
        const mollieAPI = window.location.protocol + "//" + window.location.host + "/api/payment-methods";
        axios
            .get(mollieAPI)
            .then((response) => {
                // Filter out the allowed payments
                let filtered = Object.keys(response.data.paymentMethods).filter(function (payment) {
                    let allow = false;
                    allowedPayments.forEach(function (allowed) {
                        if (response.data.paymentMethods[payment].id === allowed) {
                            allow = true;
                        }
                    });
                    return allow;
                });

                filtered = filtered.map(function (payment) {
                    return response.data.paymentMethods[payment];
                });

                // Add pay by wire (op rekening) option, and disregard the other options
                if (
                    loggedInUser?.company?.price_settings !== null &&
                    loggedInUser?.company?.price_settings.allow_pay_by_wire == true
                ) {
                    filtered = [
                        {
                            description: props.textData["checkout/form"]["pay_by_wire"],
                            id: "paybywire",
                        },
                    ];
                }
                setPaymentMethods(filtered);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    useEffect(() => {
        props.setPaymentMethods(paymentMethods);
    }, [paymentMethods]);

    function changePayment(e) {
        // Hide all
        hiddenSelects.current.forEach(function (select) {
            select.style.display = "none";
        });

        const id = paymentMethods[e.target.value]?.id;

        props.setPaymentChoice((prev) => {
            return {
                ...prev,
                id: id,
                service: e.target.parentNode.innerText,
                issuer: null,
            };
        });
    }

    function selectIssuer(e) {
        props.setPaymentChoice((prev) => {
            return {
                ...prev,
                issuer: e.target.value,
            };
        });
    }

    return (
        <div>
            <div className="payment">
                {Object.keys(paymentMethods).map(function (key, index) {
                    let expand = false;
                    if (paymentMethods[index].issuers && paymentMethods[index].issuers.length > 0) {
                        expand = paymentMethods[index].issuers.map(function (issuer) {
                            return (
                                <option value={issuer.id} key={issuer.id}>
                                    {issuer.name}
                                </option>
                            );
                        });
                    }

                    return (
                        <div key={paymentMethods[index].id}>
                            <label className="custom-checkbox">
                                <input type="radio" name="payment" value={index} onChange={changePayment} />
                                <span className="checkmark"></span>
                                {paymentMethods[index].description}
                            </label>
                        </div>
                    );
                })}
                {paymentMethods.length === 0 && (
                    <>
                        <div className="generic-spinner">
                            <span className="spinner"></span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
